export const BATCH_TABLE_DATA_SUCCESS = "BATCH_TABLE_DATA_SUCCESS";
export const BATCH_TABLE_DATA_REQUEST = "BATCH_TABLE_DATA_REQUEST";
export const BATCH_TABLE_DATA_FAILURE = "BATCH_TABLE_DATA_FAILURE";
export const batchTableDataSuccess = (payload) => ({
    type: BATCH_TABLE_DATA_SUCCESS,
    payload,
});
export const batchTableDataRequest = (payload) => ({
    type: BATCH_TABLE_DATA_REQUEST,
    payload,
});
export const batchTableDataFailure = (payload) => ({
    type: BATCH_TABLE_DATA_FAILURE,
    payload,
});
